export default {
  title: 'Contatos corporativos',
  description: 'Configure os canais corporativos por área de atendimento.',
  labels: {
    new: 'Novo contato',
  },
  fields: {
    area: 'Área',
    whatsapp: 'WhatsApp',
    email: 'E-mail',
    active: 'Ativo',
  },
  areas: {
    support: 'Suporte',
    technical: 'Técnica',
    commercial: 'Comercial',
    billing: 'Financeiro',
  },
  errors: {
    ck_contact_channels_area: 'Selecione uma área válida.',
    ck_contact_channels_whatsapp: 'Informe um número de WhatsApp válido com DDI e DDD.',
    ck_contact_channels_destination: 'Informe ao menos um WhatsApp ou e-mail.',
    uq_contact_channels_area: 'Já existe um contato configurado para esta área.',
  },
};
